import { lazy } from "react";
import { Routes as Switch, Route } from "react-router-dom";
import Paths from "./Paths";
import ProtectedRoute from "./ProtectedRoute";
import AuthContextProvider from "context/AuthContext";

const LogIn = lazy(() => import( "pages/Auth/LogIn" ));
const ForgotPassword = lazy(() => import( "pages/Auth/ForgotPassword" ));
const ResetPassword = lazy(() => import( "pages/Auth/ResetPassword" ));

const Home = lazy(() => import( "pages/Home"));
const TerritorialUnits = lazy(() => import( "pages/TerritorialUnits" ));
const DocumentTypes = lazy(() => import( "pages/DocumentTypes" ));
const DocumentsStart = lazy(() => import( "pages/Documents/DocumentsStart" ));
const DocumentsList = lazy(() => import( "pages/Documents/DocumentsList" ));
const MessageTemplates = lazy(() => import( "pages/MessageTemplates" ));
const Messages = lazy(() => import( "pages/Messages" ));
const FileArchives = lazy(() => import( "pages/FileArchives" ));
const Users = lazy(() => import( "pages/Users" ));
const AnalysisView = lazy(() => import( "pages/Analysis" ));
const NotFound = lazy(() => import( "pages/NotFound" ));

export default function Routes() {
   return (
      <Switch>
         <Route path={ Paths.PublicAnalysis } element={ <AnalysisView/> }/>

         <Route element={ <AuthContextProvider/> }>
            <Route element={ <ProtectedRoute/> }>
               <Route path={ Paths.Auth.Login } element={ <LogIn/> }/>
               <Route path={ Paths.Auth.ForgotPassword } element={ <ForgotPassword/> }/>
               <Route path={ Paths.Auth.ResetPassword } element={ <ResetPassword/> }/>
            </Route>

            <Route element={ <ProtectedRoute need_auth/> }>
               <Route path={ Paths.Home } element={ <Home/> }/>
               <Route path={ Paths.TerritorialUnits } element={ <TerritorialUnits/> }/>
               <Route path={ Paths.DocumentTypes } element={ <DocumentTypes/> }/>
               <Route path={ Paths.Documents.Start } element={ <DocumentsStart/> }/>
               <Route path={ Paths.Documents.List()} element={ <DocumentsList/> } />
               <Route path={ Paths.MessageTemplates } element={ <MessageTemplates/> }/>
               <Route path={ Paths.CorrespondenceWithUnits } element={ <Messages/> }/>
               <Route path={ Paths.FileArchives } element={ <FileArchives/> }/>
               <Route path={ Paths.Users } element={ <Users/> }/>
               <Route path={ Paths.Analysis } element={ <AnalysisView/> }/>

               <Route path="*" element={ <NotFound/> }/>
            </Route>
         </Route>
      </Switch>
   )
}
